module.exports = __webpack_public_path__ + "img/trawling-web-logo-versio-web.a40b8321.png";